import InstructionsForUse from './InstructionsForUse'

export default InstructionsForUse
